var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"w-100",attrs:{"id":_vm.fn_isNull(_vm.id) ? 'map' : _vm.id}},[_c('div',{staticClass:"marker-custom"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }